import { render, staticRenderFns } from "./PickedupShippings.vue?vue&type=template&id=bd444792"
import script from "./PickedupShippings.vue?vue&type=script&lang=js"
export * from "./PickedupShippings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports